export default {
  ApplicationInfo: '申请信息',
  Game: '游戏',
  Account: '账号',
  Server: '服务器',
  CharacterName: '角色名',
  PlatformOrderNumber: '平台订单号',
  Amount: '金额',
  InvoiceMethod: '开票方式',
  InvoiceByTotalOrderAmount: '按订单总额开票',
  InvoiceByOrderAmountSeparately: '按订单金额，分开开票',
  PhoneNumber: '联系电话',
  Name: '姓名',
  Address: '地址',
  InvoiceTitle: '发票抬头',
  PersonalTitleOnlyNoCompany: '仅支持个人抬头，不支持公司抬头',
  ReceivingEmail: '接收邮箱',
  Remarks: '备注',
  InputContent: '输入内容',
  ApplicationSubmittedSuccessfully: '申请提交成功',
  InvoiceApplicationSubmittedSuccessfully:
    '您的发票申请已提交成功\r\n工作人员将在7个工作日内处理，请注意查收邮件',
  Confirm: '确定',
  Submit: '提交',
  ApplicationSubmissionFailed: '申请提交失败',
  InvoiceApplicationFailed: '您的发票申请提交失败。请刷新重试或联系客服',
  InvoiceApplicationSubmitted: '您的发票申请已提交，请勿重复提交',
  PleaseEnterName: '请输入姓名',
  PleaseEnterAddress: '请输入地址',
  PleaseEnterInvoiceTitle: '请输入发票抬头',
  PleaseEnterEmail: '请输入接收邮箱',
  PleaseEnterRemarks: '请输入备注信息',
  NumberParsingError: '号码解析错误',
  PleaseEnterValidEmailFormat: '请输入有效的邮箱格式',
  IncompleteInformation: '信息不完整，请检查',
  ExpandAll: '展开全部'
};
